import QRCode from 'qrcode';
import {mc} from '@/core';
import {userApi} from '@/api';
import {doCaptcha} from '@/captcha';
import lang from '@/modules/login/LoginPage.lang';

export enum QrType {
  NEW = 'NEW',
  SCAN = 'SCAN',
  CONFIRM = 'CONFIRM',
  EXPIRED = 'EXPIRED',
}

export async function getQrcode(LG) {
  const captchaResult = await doCaptcha('login');
  if (!captchaResult) {
    mc.send('toast', 'error', {message: LG(lang.NetworkError)});
    return;
  }
  const {data, error} = await userApi.getLoginQrcode(captchaResult);
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

export async function scanLoginStatus(p) {
  const {data, error} = await userApi.checkLoginQrStatus(p);
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

export async function confirmQrLogin(p, LG) {
  const {data, error} = await userApi.confirmLoginQr(p, LG);
  if (data) {
    return data;
  }
  if (error) {
    mc.send('toast', 'error', error);
  }
}

export function genQrcodeUrl(qrCodeUrl, callback) {
  if (qrCodeUrl) {
    QRCode.toDataURL(qrCodeUrl).then((url) => {
      callback?.(url);
    });
  }
}
